// extracted by mini-css-extract-plugin
export default {"one":"SecOne_one__G5uzH","oneMain":"SecOne_oneMain__vsSHL"};